module.exports = ".header-less-tabs.mat-tab-group .mat-tab-header {\n  display: none; }\n"